import _sfc_main from "./component-library220.mjs";
import "./component-library221.mjs";
import normalizeComponent from "./component-library92.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.Dropdown, { ref: "dropdownElement", staticClass: "list-dropdown", class: _setup.containerClass, attrs: { "opened": _vm.opened, "disabled": _setup.isDisabled, "auto-width": _vm.autoWidth }, on: { "toggle": _setup.onToggle }, scopedSlots: _vm._u([{ key: "caption", fn: function() {
    return [_vm.labelOnSelection && _setup.hasSelection ? _vm._t("selection", function() {
      return [_vm._v(" " + _vm._s(_setup.selectedLabels) + " ")];
    }, { "selection": _setup.selection }) : _vm._t("placeholder", function() {
      return [_vm._v(" " + _vm._s(_vm.placeholder) + " ")];
    })];
  }, proxy: true }, { key: "input", fn: function() {
    return [_vm.hasSearch ? _c(_setup.TextInput, { ref: "searchInputElement", staticClass: "list-dropdown__search-input", attrs: { "id-prefix": "Search", "placeholder": "Produkt suchen" }, nativeOn: { "input": function($event) {
      return _setup.updateSearchResults.apply(null, arguments);
    } }, model: { value: _setup.searchInput, callback: function($$v) {
      _setup.searchInput = $$v;
    }, expression: "searchInput" } }) : _vm._e()];
  }, proxy: true }, { key: "default", fn: function() {
    return [_c("div", { staticClass: "list-dropdown__items", attrs: { "role": "listbox" } }, [_vm.includeBlank ? _c(_setup.DropdownItem, { attrs: { "value": void 0, "selected": !_setup.hasSelection, "label": _vm.includeBlank, "url": _setup.buildItemUrl(null) }, on: { "click": _setup.selectAndMaybeChange } }) : _vm._e(), _vm._l(_setup.filteredOptions, function(option, index) {
      return [_vm.groupEntries && (index === 0 || _setup.filteredOptions[index - 1].groupName !== option.groupName) ? _c("div", { key: `groupname_${index}`, staticClass: "btn btn--small-padding btn--secondary list-dropdown__item-group-name" }, [_vm._v(" " + _vm._s(option.groupName) + " ")]) : _vm._e(), _c(_setup.DropdownItem, { key: index, attrs: { "label": option.label, "value": option.value, "count": option.count, "selected": _setup.isSelected(option.value), "url": _setup.buildItemUrl(option.value) }, on: { "click": _setup.selectAndMaybeChange }, scopedSlots: _vm._u([{ key: "beforeLabel", fn: function() {
        return [_vm._t("beforeLabel", null, { "option": option })];
      }, proxy: true }], null, true) })];
    })], 2)];
  }, proxy: true }, { key: "submit", fn: function() {
    return [_vm.multiple ? _c(_setup.LinkButton, { attrs: { "tag": "button", "type": "button", "primary": "", "small-padding": "", "is-wide": "", "disabled": !_setup.hasChanged }, on: { "click": _setup.change } }, [_vm._v(" " + _vm._s(_vm.buttonText) + " ")]) : _vm._e()];
  }, proxy: true }], null, true) });
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "8afada1d",
  null,
  null
);
const ListDropdown = __component__.exports;
export {
  ListDropdown as default
};
